import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { ToggleBtnFilter } from "./_common/toggle-btn-filter";

type Option = { label: string; value: string | null };

export type GroupInvoicingFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const IsNationalFilter = ({
  label,
  options,
  ...props
}: GroupInvoicingFilterProps) => {
  const title = label ?? locale.NationalProcurement;

  return (
    <ToggleBtnFilter
      label={title}
      options={[
        { value: "true", label: "Ja" },
        { value: "false", label: "Nej" }
      ]}
      {...props}
    />
  );
};
